import { Link } from "react-router-dom";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";
import { useTitle } from "../App";

export default function NotFound() {
  useTitle("Page not found");
  return (
    <div data-testid="not-found-page" className="min-h-screen bg-midnight text-mist">
      <Navbar />
      <div className="container-ek flex min-h-[75vh] flex-col items-center justify-center text-center">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-teal">404</p>
        <h1 className="mt-4 font-display text-4xl font-bold tracking-tight sm:text-6xl">This page has wandered off.</h1>
        <p className="mt-5 max-w-md text-sm leading-relaxed text-slate-400">
          The page you are looking for does not exist or is not published. The rest of the site is very much here.
        </p>
        <div className="mt-9 flex flex-wrap justify-center gap-4">
          <Link to="/" data-testid="nf-home" className="btn-primary">Back to Home</Link>
          <Link to="/contact" className="btn-ghost">Contact Us</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
